// Imports
var ___HTML_LOADER_IMPORT_0___ = new URL("./oauth.js", import.meta.url);
// Module
var code = "<!DOCTYPE html> <html> <head> <title>QuickBooks OAuth Callback</title> <" + "script src=\"https://appsforoffice.microsoft.com/lib/1/hosted/office.js\"><" + "/script> <" + "script src=\"" + ___HTML_LOADER_IMPORT_0___ + "\"><" + "/script> </head> <body> <h2>Authentication with QuickBooks</h2> </body> </html>";
// Exports
export default code;